import { render } from "./Mails.vue?vue&type=template&id=33115424&scoped=true"
import script from "./Mails.vue?vue&type=script&lang=js"
export * from "./Mails.vue?vue&type=script&lang=js"

import "./Mails.vue?vue&type=style&index=0&id=33115424&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33115424"]])

export default __exports__